var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"min-width":"950px","min-height":"600px"},attrs:{"app":""}},[_c('v-main',[(!_vm.$route.meta.hideNavbar)?_c('navigation'):_vm._e(),_c('router-view',{staticStyle:{"min-height":"100%","font-family":"'Roboto', sans-serif"}}),(!_vm.$route.meta.hideNavbar)?_c('irraaFooter'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }